const TopKaoKhorView = {
    pageID: '5',
    title: '5 จุดชมวิวเขาค้อสุดฮิต',
    prevDescription: 'สำหรับใครที่กำลังมีแพลนไปเที่ยวเขาค้อเร็วๆนี้ห้ามพลาด 5 จุดสวยๆเหล่านี้เป็นอันขาด กับ 5 จุดชมทะเลหมอกสวยๆที่เขาค้อ',
    topicDescription: 'เขาค้อสวรรค์ของการท่องเที่ยวพักผ่อนหย่อนใจสำหรับใครหลายๆคน เชื่อได้เลยว่าหลายคนคงเคยไป หรือกำลังวางแผนไปเที่ยวที่นี่กันเป็นแน่แท้ ดังนั้นสำหรับใครที่กำลังมีแพลนไปเที่ยวเขาค้อเร็วๆนี้ห้ามพลาด กับจุดชมวิวสวยๆเหล่านี้ในเขาค้อ โดยเฉพาะสายถ่ายรุปนั้นพลาดไม่ได้จริงๆ จะมีจุดไหนกันบ้างตามไปดูกันได้เลย ไป๊ ชิ๊วๆ~~',
    previewImg: 'https://cms.dmpcdn.com/travel/2024/06/07/f24e4a90-249c-11ef-974e-837db649ec15_webp_original.webp',

    data: [
        {
            id: 1,
            title: 'จุดชมวิวไปรษณีย์เขาค้อ',
            description: 'ที่ทำการไปรษณีย์เขาค้อ จุดชมทะเลหมอกเขาค้อ เป็นที่ที่สวยงามมากๆอีกแห่ง ตั้งอยู่ริมเส้นทางสาย 2196 ตรงจุดนี้เราจะได้เห็นทะเลหมอกสุดอลังการ อีกทั้งวิวจากจุดชมวิวนี้จะเป็นมุมกว้าง 180 องศา',
            src: 'https://cms.dmpcdn.com/travel/2024/06/07/f2076870-249a-11ef-974e-837db649ec15_webp_original.webp',
        },
        {
            id: 2,
            title: 'จุดชมวิวกังหันลมเขาค้อ',
            description: 'ทุ่งกังหันลมเขาค้ออยู่บนความสูงกว่า 1,050 เมตร ทำให้จุดชมวิวตรงบริเวณนี้สามารถชมวิวได้รอบแบบพาโนรามา 360 องศาเลยทีเดียว และยังเห็นไปไกลถึงวัดพระธาตุผาซ่อนแก้วอีกด้วย',
            src: 'https://www.khaokho.com/images/editor/Windturbine7.jpg',
        },
        {
            id: 3,
            title: 'จุดชมวิววัดกองเนียม',
            description: 'เราสามารถมาชมพระอาทิตย์ขึ้นแสงแรกของวันพร้อมทะเลหมอกได้ที่นี่ จุดชมวิววัดกองเนียม ซึ่งตั้งอยู่ใกล้กับหอสมุดนานาชาติ และติดกับทางขึ้นไปชมอนุสรณ์สถานเขาค้อ ที่นี่เป็นจุดชมวิวทะเลหมอกที่สวยงามของเขาค้อ เป็นทะเลหมอกท่ามกลางเนินเขาสลับซับซ้อน โดยมีต้นค้อสูงใหญ่เป็นฉากหน้า และมีแสงสีส้มสวยจากดวงอาทิตย์ที่สวยงามเป็นฉากหลัง',
            src: 'https://cms.dmpcdn.com/travel/2020/12/30/4803a8f0-4a84-11eb-813d-c9afb860c652_original.jpg',
        },
        {
            id: 4,
            title: 'จุดชมวิวร้านกาแฟ Pino Latte\nวัดผาซ่อนแก้ว',
            description: 'อีกหนึ่งจุดชมวิวทะเลหมอกยอดนิยมบนเขาค้อก็คือ จุดชมวิว ร้านกาแฟ Pino Latte ซึ่งตั้งอยู่ไม่ไกลจากวัดผาซ่อนแก้ว ซึ่งในฤดูฝนนั้นบริเวณนี้จะเต็มไปด้วยหมอกสีขาวลอยฟุ้ง เป็นจุดที่สวยงามที่สุดในฤดูฝนของเขาค้อเลยทีเดียว',
            src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh9q1ucAuVgA3WMKvK0mDeXFwarZeETSKugj2MN5DSXV_PfNPw9GIw0tuQGvbfvynzruF_jeXya2scGp15lj0oNq1U5lqt8Vvtt1Q87sBUnPoR4RrU7LpYqzjiPmjFn94y6R0fEo062ZAo/s1600/edit-5648.jpg',
        },
        {
            id: 5,
            title: 'จุดชมวิวเขาตะเคียนโง๊ะ',
            description: 'จุดชมวิวเขาตะเคียนโง๊ะ ตั้งอยู่บนถนนสาย 2258 ตรงจุดนี้เราจะสามารถมองเห็นวิวสวยๆของทะเลหมอกได้ถึง 360 องศาเลยทีเดียว แถมยังเป็นจุดชมพระอาทิตย์ขึ้นอีกด้วย นักท่องเที่ยวสามารถมาพักค้างคืนได้โดยจะมีให้บริการเช่าเต็นท์ แต่ที่ด้านบนจะไม่มีร้านอาหารมีแค่ร้านขายของเล็กๆ',
            src: 'https://cms.dmpcdn.com/travel/2022/06/13/50da7330-ead5-11ec-8ce9-d781f80ed1c8_webp_original.jpg',
        },
    ]
}

export default TopKaoKhorView